import { render, staticRenderFns } from "./costHelp.vue?vue&type=template&id=a9d0b358&"
import script from "./costHelp.vue?vue&type=script&lang=js&"
export * from "./costHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9d0b358')) {
      api.createRecord('a9d0b358', component.options)
    } else {
      api.reload('a9d0b358', component.options)
    }
    module.hot.accept("./costHelp.vue?vue&type=template&id=a9d0b358&", function () {
      api.rerender('a9d0b358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FPykQaH1j6JR/JS/costHelp.vue"
export default component.exports